import { render, staticRenderFns } from "./DeveloperListCommercialBuildings.vue?vue&type=template&id=d9f48840&"
import script from "./DeveloperListCommercialBuildings.vue?vue&type=script&lang=js&"
export * from "./DeveloperListCommercialBuildings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports